import { render, staticRenderFns } from "./UserProfileMembership.vue?vue&type=template&id=55a7fa43&scoped=true&"
import script from "./UserProfileMembership.vue?vue&type=script&lang=js&"
export * from "./UserProfileMembership.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileMembership.vue?vue&type=style&index=0&id=55a7fa43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a7fa43",
  null
  
)

export default component.exports